// JavaScript equivalent of Python TextChoices enums
export const GalleryDisplayType = {
  HORIZONTAL: { value: "h", label: 'Horizontal' },
  VERTICAL: { value: "v", label: 'Vertical' },
  COMPACT_THUMB: { value: "ct", label: 'Compact Thumb' },
  COMPACT_HORIZONTAL: { value: "ch", label: 'Compact Horizontal' },
  REEL: { value: "r", label: 'Reel' },
  CONTAINER: { value: "n", label: 'Container' },
  
  // Helper methods
  fromValue(value) {
    return Object.values(this).find(type => 
      typeof type === 'object' && type.value === value
    );
  },
  
  values() {
    return Object.values(this)
      .filter(item => typeof item === 'object')
      .map(item => item.value);
  },
  
  choices() {
    return Object.values(this)
      .filter(item => typeof item === 'object')
      .map(item => [item.value, item.label]);
  }
};

export default GalleryDisplayType;